// Shared by the campaign cards and Hamza's record: one source for the published figures.
export const TRACK_RECORD = [
  { name: "Unity Technologies", wordmark: "Unity", metric: "$880K", metricLabel: "in software revenue" },
  { name: "Easefix", wordmark: "Easefix", metric: "$255K", metricLabel: "closed in sales" },
  { name: "Evercam", wordmark: "Evercam", metric: "$160K", metricLabel: "closed in six months" },
];
